export class RadialFillFilter extends PIXI.Filter<any> {
    private static readonly FRAG: string = `
        varying vec2 vTextureCoord;
        uniform vec4 filterArea;
        uniform vec2 dimensions;

        uniform sampler2D uSampler;
        uniform vec3 uColourCurr;
        uniform vec3 uColourPrev;
        uniform float uPerc;
        uniform vec2 uOrigin;

        vec2 mapCoord(vec2 coord)
        {
            coord *= filterArea.xy;
            return coord;
        }

        void main() {
            vec2 pixelCoord = vTextureCoord * filterArea.xy;
            vec2 localCoord = pixelCoord / dimensions;
            float alpha = texture2D(uSampler, vTextureCoord).a;
            float dist = sqrt(
                (localCoord.x - uOrigin.x) * (localCoord.x - uOrigin.x) +
                (localCoord.y - uOrigin.y) * (localCoord.y - uOrigin.y)
            ) / 1.42;
            dist = max(0.01, dist);
            vec3 colour = vec3(uColourPrev * ceil(dist - uPerc) + uColourCurr * ceil(uPerc - dist));
            colour = colour * alpha;
            gl_FragColor = vec4(colour, alpha);
        }
    `;

    constructor() {
        super(undefined, RadialFillFilter.FRAG);
    }
}
